import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import * as api from "../../api";
import {useTranslation} from "react-i18next";
import {useFeedbackTools} from "../../components/FeedbackTools";
import {useNavigate} from "react-router-dom";


export const useWorkgroupQuery = (workgroupId) => {
    return useQuery({
        queryKey: ['workgroups', workgroupId],
        queryFn: () => api.Workgroup.getWorkgroup(workgroupId),
        keepPreviousData: true
    });
}


export const useCreateWorkgroup = () => {
    const {t} = useTranslation(["workgroups"])
    const queryClient = useQueryClient();
    const {showSuccessNotification} = useFeedbackTools();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: async (data) => await api.Workgroup.createWorkgroup(data),
        onSuccess: (data) => {
            queryClient.invalidateQueries(['workgroups']);
            showSuccessNotification(t('query.createSuccess'));
            navigate(`/workgroups`);
        }
    });
}

export const useUpdateWorkgroup = (workgroupId) => {
    const {t} = useTranslation(["workgroups"])
    const queryClient = useQueryClient();
    const {showSuccessNotification} = useFeedbackTools();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: async (data) => await api.Workgroup.updateWorkgroup(workgroupId, data),
        onSuccess: (data) => {
            queryClient.invalidateQueries(['workgroups']);
            showSuccessNotification(t('query.updateSuccess'));
            navigate(`/workgroups/${workgroupId}`);
        }
    });
}